/// <reference path="skyward.ui.modallayer.ts" />
/// <reference path="skyward.ui.window.ts"/>
/// <reference path="skyward.ui.calculatedfieldlist.js"/>
/// <reference path="skyward.base.searchCondition.ts"/>
(
    function (skyward, $, undefined)
    {
        skyward.filterbuilder = skyward.filterbuilder || {};

        var init = function (selector)
        {
            const filterBuilderLaunchButton = $(selector + " .filterBuilderLaunchButton");
            if (filterBuilderLaunchButton.length > 0)
            {
                const filterBuilderLaunchButtonData = filterBuilderLaunchButton.data();
                if (filterBuilderLaunchButtonData)
                {
                    if (filterBuilderLaunchButtonData.reparenterInputClass)
                    {
                        setupReparentingOnInputChange(selector, filterBuilderLaunchButtonData.reparenterInputClass);
                    }
                    if (filterBuilderLaunchButtonData.objectCodeEelId && filterBuilderLaunchButtonData.moduleCodeEelId)
                    {
                        setupCodeEELReparenting(selector, filterBuilderLaunchButtonData.objectCodeEelId, filterBuilderLaunchButtonData.moduleCodeEelId);
                    }
                }
            }

            filterBuilderLaunchButton.off("click.filterBuilder").on("click.filterBuilder", skyward.filterbuilder.showFilter);
            $(selector + " .filterBuilderAddGroup, .filterBuilderAddRow").off("click.filterBuilder").on("click.filterBuilder", addPart);
            $(selector + " .filterBuilderFieldSelect").off("click.filterBuilder").on("click.filterBuilder", skyward.filterbuilder.getTreeBrowse);
            $(selector + " .conditionTypesComboBox").off("change.filterBuilder").on("change.filterBuilder", getValueControl);
            $(selector + " .applyDistrictEntityFilter").off("change.filterBuilder").on("change.filterBuilder", updateDistrictEntityFilter);
            $(selector + " .checkbox.schemaObjectFilter").off("change.filterBuilder").on("change.filterBuilder", updateFriendlyQuery);
            $(selector + " .conditionValue").off("keydown.filterBuilder blur.filterBuilder dirty.filterBuilder change.filterBuilder")
                .on("keydown.filterBuilder", function ()
                {
                    $(this).data("promptUniqueId", null).data('environmentVariableBinding', null).data('enumCodeValue', null).prev(".svgHolder").html("");
                })
                .on("blur.filterBuilder dirty.filterBuilder change.filterBuilder", function ()
                {
                    $(this).removeClass("active");
                    updateFriendlyQuery();
                });

            $(selector + " .environmentVariablesContainer:not(.promptBuilder)")
                .siblings(".removeEnvironmentVariableButton").off('click.filterBuilder')
                .on('click.filterBuilder', hideEnvironmentVariables)
                .end()
                .siblings('.addEnvironmentVariableButton').first().off('click.filterBuilder')
                .on('click.filterBuilder', showEnvironmentVariables);

            $(selector + " .conditionGroupTypeRadioButtonGroup").find("input:radio").off("change.filterBuilder")
                .on("change.filterBuilder", function ()
                {
                    const radioButton = $(this);
                    const andOr = radioButton.val();
                    const conditionGroupControlsContainer = radioButton.closest(".conditionGroupControlsContainer");
                    conditionGroupControlsContainer.siblings(".andOrText").html(andOr);
                    conditionGroupControlsContainer.siblings(".condition").find(".andOrText").html(andOr);
                    updateFriendlyQuery();
                });

            $(selector + " .removeFilterBuilderCondition").off("click.filterBuilder")
                .on("click.filterBuilder", function ()
                {
                    removePart($(this).closest(".condition"));
                });

            $(selector + " .removeFilterBuilderGroupCondition").off("click.filterBuilder")
                .on("click.filterBuilder", function ()
                {
                    removePart($(this).closest(".conditionGroup"), true);
                });

            $(selector + " .filterViewerDisplay").off('change.filterBuilder')
                .on('change.filterBuilder', function ()
                {
                    updateFriendlyQuery($(this));
                });

            $(selector + " .filterViewValue").off("change.filterBuilder updateFilterViewerDisplay")
                .on("change.filterBuilder updateFilterViewerDisplay", updateFilterViewerDisplay)
                .each(updateFilterViewerDisplay);

            $(selector + " .js-bindingConditionValue").off('click.filterBuilder')
                .on('click.filterBuilder', function ()
                {
                    hideConditionValueSpan($(this));
                });
        };

        function checkIsReportMode(popupButton)
        {
            return (popupButton.data('mode') || "").toLowerCase() === "report";
        }

        var updateFilterViewerDisplay = function ()
        {
            const filterViewInput = $(this);
            const searchCondition = skyward.searchCondition.getFromJson(filterViewInput.data("filterCondition"), convertBindingsToFriendlyNames);
            const friendlyQuery = searchCondition.toFriendlyQuery();
            filterViewInput.siblings(".filterViewerDisplay").val(friendlyQuery);
        };

        skyward.filterbuilder.updateFilterViewerDisplay = function (filterViewInput)
        {
            updateFilterViewerDisplay.apply(filterViewInput);
        };

        skyward.filterbuilder.getFieldsUsedInFilterBuilder = function (conditionContainer, traverseExists, convertImages = true)
        {
            const searchCondition = extractNewConditionGroup(conditionContainer);
            const searchConditionFieldsData = searchCondition.getFieldsFromCondition(traverseExists);

            let filterFields = [];

            searchConditionFieldsData.forEach(fieldData =>
            {
                if (!fieldData.calculatedFieldName)
                {
                    const field = skyward.reporting.buildUsedInReportField(fieldData.fieldPath, fieldData.fieldName, fieldData.displayName, fieldData.displayPath, fieldData.fieldType, fieldData.parameters, false, fieldData.isOperation, false, convertImages);
                    filterFields.push(field);
                }
            });

            return filterFields;
        }

        var hideConditionValueSpan = function (span)
        {
            var spanData = span.data();

            if ("boolvalue" in spanData || "enumType" in spanData)
            {
                return;
            }
            var input = span.closest(".conditionValuesContainer").find(".js-valueConditionValue");

            span.off('click');
            span.setAllDataToNull();

            if (input.length)
            {
                skyward.controls.show(input, false);
                input.css("display", "");
                input.removeClass("hidden");
                input.addClass("js-conditionValue--active");
                span.addClass("hidden");
                span.removeClass("js-conditionValue--active");

                input.focus();
            }
        };

        var filterBuilderDialogs = skyward.filterbuilder.dialogs = (function ()
        {
            let dialogs = [];
            let self = {};

            self.register = function (dialog)
            {
                dialogs.push(dialog);
            };

            self.getCurrent = function ()
            {
                return dialogs[dialogs.length - 1];
            };

            self.closeCurrent = function ()
            {
                dialogs[dialogs.length - 1].close();
                dialogs.pop();
            };

            return self;
        })();

        var updateFriendlyQuery = function ()
        {
            const dialog = filterBuilderDialogs.getCurrent();

            if (dialog)
            {
                const container = dialog.content.find(".filterBuilder > .conditionsContainer");
                const searchCondition = extractNewConditionGroup(container);
                const schemaObjectFilterConditions = extractSchemaObjectSearchConditions(container);

                if (schemaObjectFilterConditions)
                {
                    // the main search condition will always be an "And" condition so we can add it to it directly
                    searchCondition.addCondition(schemaObjectFilterConditions);
                }

                const districtEntityFilter = extractNewDistrictEntityFilter(dialog.content.find(".districtEntityContainer"));

                if (districtEntityFilter)
                {
                    searchCondition.addCondition(districtEntityFilter);
                }

                const friendlyQueryDiv = dialog.content.find(".currentQuery").find("div");
                friendlyQueryDiv.empty();
                friendlyQueryDiv.html($("<p>").text(skyward.extensions.decodeHtml(searchCondition.toFriendlyQuery())));
            }
        };

        var addPart = function ()
        {
            const button = $(this);
            const buttonData = button.data();

            const builderButtonsDiv = button.parent(".builderButtons");

            const dataObjectFullName = buttonData.dataObjectFullName;

            const renderAndOr = button.hasClass("filterBuilderAddGroup") && builderButtonsDiv.siblings(".condition, .conditionGroup").length > 0;

            const filterBuilderData = button.closest(".filterBuilder").data();
            $.ajax({
                url: skyward.global.virtualDir + buttonData.addparturl,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    dataObjectFullName: dataObjectFullName,
                    renderAndOr: renderAndOr,
                    andOr: builderButtonsDiv.siblings(".conditionGroupControlsContainer").find("input:checked").val(),
                    mode: buttonData.mode,
                    lookupModule: buttonData.module,
                    lookupObject: buttonData.object,
                    rootModule: buttonData.rootModule,
                    rootObject: buttonData.rootObject,
                    seekField: buttonData.field,
                    relationshipPath: buttonData.relationshipPath,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    routehash: filterBuilderData.routehash
                },
                success: function (data)
                {
                    $(data).insertBefore(builderButtonsDiv);
                    updateFriendlyQuery();
                    const currentPopupId = skyward.window.getCurrentPopupId();
                    const selector = ".modalLayerContainer[data-layerid='" + currentPopupId + "'] .filterBuilder";
                    skyward.window.notifyDOMLoad(selector);
                    const layerData = skyward.modalLayer.getLayerFromElement(".modalLayerContainer[data-layerid='" + currentPopupId + "']");
                    if (layerData && layerData.container)
                    {
                        layerData.container.resize();
                    }
                }
            });
        };

        var removePart = function (containerToRemove, isConditionGroup)
        {
            var andOr = containerToRemove.prev(".andOrText");
            if (andOr.length <= 0 && isConditionGroup) //removing the first container
            {
                andOr = containerToRemove.next(".andOrText");
            }
            andOr.remove();
            containerToRemove.remove();
            updateFriendlyQuery();

            var layerData = skyward.modalLayer.getLayerFromElement(".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "']");
            if (layerData && layerData.container)
            {
                layerData.container.resize();
            }
        };

        /* getTreeBrowse and getTreeBrowseForFieldToField supporting functions */

        function fieldColumnPopupMultiPanel(contents, data, events)
        {
            const jqContents = $(contents);

            const standardFilterButton =
            {
                text: "Select Standard Filters",
                click: events.standardFilterButtonClicked,
                icon: "Save",
                additionalClasses: ["standardFilterButton"]
            };
            const saveButton =
            {
                text: "Select Field",
                click: events.saveButtonClicked,
                icon: "Save",
                additionalClasses: ["filterSaveButton"]
            };
            const cancelButton =
            {
                text: "Cancel",
                click: "close",
                icon: "Cancel"
            };

            const options =
            {
                animationDuration: 0,
                draggable: true,
                closeOnClick: false
            };

            const buttons = data.showStandardFilterButton ? [standardFilterButton, saveButton, cancelButton] : [saveButton, cancelButton];

            const browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);
            skyward.filterbuilder.fieldSelectorDialog = browseDialog;

            const container = filterBuilderDialogs.getCurrent().content.find(".filterBuilder > .conditionsContainer");

            browseDialog.bodyPromise.done(function ()
            {
                initializePanels(container, browseDialog, events, data);
            });

            const fieldSearchInput = browseDialog.content.find(".js-treebrowse__fieldSearchInput");
            const fieldSearchButton = browseDialog.content.find(".js-searchBoxButton");
            fieldSearchInput.on("enter", function ()
            {
                fieldSearchButton.click();
            });
        }

        function initializePanels(container, browseDialog, events, data)
        {
            const filterFields = skyward.filterbuilder.getFieldsUsedInFilterBuilder(container, false);
            let usedfields;
            if (data.fieldDataType)
            {
                usedfields = skyward.reporting.fields.buildFieldsListOfType(data.fieldDataType, filterFields, data.sectionID, true, true);
            }
            else
            {
                usedfields = skyward.reporting.fields.buildFieldsList(filterFields, data.sectionID, true, true);
            }

            let calculatedFields;
            if (data.fieldDataType)
            {
                calculatedFields = Object.values(skyward.reporting.calculatedFields.AllFieldsOfType(data.fieldDataType));
            }
            else
            {
                calculatedFields = Object.values(skyward.reporting.calculatedFields.AllFields());
            }
            const filteredCalculatedFields = skyward.calculatedFieldList.filterCalculatedFieldList(calculatedFields, data.rootModule, data.rootObject, data.relationshipPath, data.rootExistsPath);
            const convertedCalculatedFields = skyward.reporting.fields.buildCalculatedFieldsList(filteredCalculatedFields);

            const panelData =
                [{
                    selector: ".js-usedFieldsPanel",
                    fields: usedfields,
                    buildFieldPath: true
                },
                {
                    selector: ".js-calculatedFieldsPanel",
                    fields: convertedCalculatedFields,
                    buildFieldPath: false
                }];
            skyward.fieldselectionpanels.initializePanels(browseDialog.content, panelData, events.fieldSelected, events.treeBrowseLevelChanged);
        }

        function buildFieldColumnPopupDialog(contents, settings)
        {
            if (!settings.isReportMode)
            {
                settings.buildTreeBrowsePopup(contents);
            }
            else
            {
                const data =
                {
                    fieldDataType: settings.fieldDataType,
                    relationshipPath: settings.fieldSelectorControlData.relationshipPath,
                    rootExistsPath: settings.filterBuilderData.rootExistsPath,
                    dataModule: settings.filterBuilderData.dataModule,
                    dataObject: settings.filterBuilderData.dataObject,
                    rootModule: settings.filterBuilderData.rootModule,
                    rootObject: settings.filterBuilderData.rootObject,
                    sectionID: settings.filterBuilderData.sectionId,
                    seekToField: settings.seekToField,
                    showStandardFilterButton: settings.showStandardFilterButton
                };
                const events =
                {
                    fieldSelected: settings.fieldSelected,
                    standardFilterButtonClicked: settings.standardFilterButtonClicked,
                    saveButtonClicked: settings.saveButtonClicked,
                    treeBrowseLevelChanged: settings.treeBrowseLevelChanged
                };
                fieldColumnPopupMultiPanel(contents, data, events);
            }
        }

        skyward.filterbuilder.getTreeBrowse = function ()
        {
            const fieldSelectorControl = $(this);
            const fieldSelectorControlData = fieldSelectorControl.data();
            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();
            const isReportMode = checkIsReportMode(fieldSelectorControl);

            let currentRelationshipPath = "";

            var fieldColumnPopup = function ()
            {
                return $.ajax(skyward.global.virtualDir + filterBuilderData.buildTreeBrowsePath,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data:
                        {
                            absoluteTreeBrowseObjectPath: fieldSelectorControlData.relationshipPath,
                            seekField: fieldSelectorControlData.absoluteFieldPath,
                            rootModule: filterBuilderData.rootModule,
                            rootObject: filterBuilderData.rootObject,
                            relationshipPath: fieldSelectorControlData.relationshipPath,
                            routehash: filterBuilderData.routehash,
                            securitymodule: filterBuilderData.securitymodule,
                            securityobject: filterBuilderData.securityobject,
                            securityscreen: filterBuilderData.securityscreen,
                            maxOneToManyNestedLevels: 10,
                            mode: fieldSelectorControlData.mode,
                            includeStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                            browseId: filterBuilderData.browseid,
                            renderOneToMany: true, // We always show one to many relationships for the left side field
                            allowOneToManyBrowse: filterBuilderData.allowOneToManyBrowse,
                            renderOperationFields: true,
                            isExistsFilterBuilder: filterBuilderData.isExistsFilterBuilder,
                            isForFieldToField: false,
                            renderCalculatedFieldsPanel: filterBuilderData.includeCalculatedFields,
                            additionalFilterTypeName: filterBuilderData.additionalFilterTypeName
                        },
                        dataFilter: function (html)
                        {
                            return buildFilterBuilderPopupWrapper(filterBuilderData, html);
                        }
                    }
                );
            };

            var standardFilterButtonClicked = function ()
            {
                var jqThis = $(this);
                var standardFilterData = jqThis.data();
                var standardFilterName = standardFilterData.standardFilterName;
                fieldSelectorControl.data({
                    "fieldType": "standardFilter",
                    "standardFilterRelationshipPath": currentRelationshipPath,
                    "standardFilterId": standardFilterData.standardFilterId
                });
                fieldSelectorControl.find("span.anchorText").text(standardFilterName);
                fieldSelectorControl.nextAll(":not(.removeFilterBuilderCondition)").remove();

                var findPromptByStandardFilterId = function (prompt, standardFilterId)
                {
                    return prompt.StandardFilterId === standardFilterId;
                };
                var existingPrompt = skyward.reporting.prompts.promptCollection.find(findPromptByStandardFilterId, standardFilterData.standardFilterId);
                var existingPromptLabel = null;
                var existingPromptId = null;

                if (existingPrompt)
                {
                    existingPromptLabel = existingPrompt.Label;
                    existingPromptId = existingPrompt.PromptUniqueId;
                }

                $.ajax({
                    url: skyward.global.virtualDir + "SkySys/Filter/GetStandardFilterValueControlData",
                    type: "POST",
                    dataType: "JSON",
                    data: {
                        standardFilterId: standardFilterData.standardFilterId,
                        reportPromptId: existingPromptId,
                        reportPromptLabel: existingPromptLabel || standardFilterData.standardFilterName
                    },
                    success: async function (data)
                    {
                        if (data.newPrompt)
                        {
                            data.newPrompt.Order = skyward.reporting.prompts.promptCollection.length + 1;
                            skyward.reporting.prompts.promptCollection.Set(data.newPrompt);
                        }

                        const processedHtml = await skyward.global.processViewPartHtml(data.valueControlHtml);
                        $(processedHtml).insertAfter(fieldSelectorControl);
                        updateFriendlyQuery();
                        var popupId = skyward.window.getCurrentPopupId();
                        $(".modalLayerContainer[data-layerid='" + popupId + "'] .filterBuilder").addClass("layerid" + popupId);
                        var selector = ".layerid" + popupId;
                        skyward.window.notifyDOMLoad(selector);
                    }
                });

                skyward.window.closePopup();
            };

            var saveButtonClicked = function (_event, dialog)
            {
                let rowData;
                if (isReportMode)
                {
                    rowData = skyward.fieldselectionpanels.getSelectedField(dialog.content);
                }
                else
                {
                    rowData = skyward.treebrowse.getSelectedFieldData(dialog.content);
                }

                selectFieldFromRow(rowData);
            };

            var treeBrowseSave = function (_event, _treeBrowseData, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var fieldSelected = function (_event, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var selectFieldFromRow = function (rowData)
            {
                if (rowData)
                {
                    updateFieldSelector(fieldSelectorControl, rowData);
                }

                skyward.window.closePopup();
            };

            var treeBrowseLevelChanged = function (_event, data)
            {
                const saveButtonTextSpan = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton .modalContentFooter__buttonText");
                const saveButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton");
                const standardFilterButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".standardFilterButton");

                const fieldPath = data.getCurrentBreadcrumb().positionObjectPath;
                const indexOfFirstPeriod = fieldPath.indexOf(".");

                if (indexOfFirstPeriod > 0)
                {
                    currentRelationshipPath = fieldPath.substring(indexOfFirstPeriod + 1);
                }
                else
                {
                    currentRelationshipPath = "";
                }

                standardFilterButton.toggle(data.standardFilterName && data.includeStandardFilterButton === true ? true : false).data("standardFilterName", data.standardFilterName).data("standardFilterId", data.standardFilterId).
                    find(".buttonText").text("Select " + data.standardFilterName);

                if (data.isDataField || !data.selectedRecord.length)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else if (data.selectedRecord.length > 0 && data.getSelectedFieldData().relationshipType === "OneToMany")
                {
                    saveButtonTextSpan.text("Select Exists");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            function fieldColumnPopupTreeBrowse(contents)
            {
                const saveButton =
                {
                    text: "Select Field",
                    "click": saveButtonClicked,
                    "icon": "Save",
                    additionalClasses: ["filterSaveButton"]
                };
                const cancelButton =
                {
                    text: "Cancel",
                    "click": "close",
                    "icon": "Cancel"
                };
                const standardFilterButton =
                {
                    text: "Select Standard Filters",
                    "click": standardFilterButtonClicked,
                    "icon": "Save",
                    additionalClasses: ["standardFilterButton"]
                };

                const options =
                {
                    animationDuration: 0,
                    draggable: true,
                    closeOnClick: false
                };
                const jqContents = $(contents);

                const buttons = [];
                if (filterBuilderData.includeStandardFilterButton)
                {
                    buttons.push(standardFilterButton);
                }
                buttons.push(saveButton, cancelButton);

                const treeBrowseId = jqContents.find(".treeBrowse").data("lookupId");

                const browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);
                skyward.filterbuilder.fieldSelectorDialog = browseDialog;

                browseDialog.content.on("treeBrowseLevelChanged", treeBrowseLevelChanged).on("treeBrowseRowChange", treeBrowseLevelChanged);
                browseDialog.content.on("treeBrowseSave", treeBrowseSave);
                if (filterBuilderData.includeCalculatedFields)
                {
                    browseDialog.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                    {
                        skyward.calculatedFieldList.updateCalculatedFieldList(
                            treeBrowseData,
                            Object.values(skyward.reporting.calculatedFields.AllFields()),
                            undefined,
                            fieldSelectorControlData.rootModule,
                            fieldSelectorControlData.rootObject,
                            fieldSelectorControlData.relationshipPath,
                            filterBuilderData.rootExistsPath
                        );
                    });
                }

                browseDialog.bodyPromise.done(function ()
                {
                    browseDialog.content.parent().find(".standardFilterButton").hide();
                });

                const treeBrowseLoaded = $.Deferred();
                browseDialog.content.one("treeBrowseContentLoaded", treeBrowseLoaded.resolve);
                $.whenAll([browseDialog.animationPromise, treeBrowseLoaded]).done(function ()
                {
                    skyward.treebrowse.seekToField(treeBrowseId);
                });
            }

            fieldColumnPopup().done(function (contents)
            {
                const settings =
                {
                    buildTreeBrowsePopup: fieldColumnPopupTreeBrowse,
                    fieldDataType: null,
                    filterBuilderData: filterBuilderData,
                    fieldSelectorControlData: fieldSelectorControlData,
                    isReportMode: isReportMode,
                    saveButtonClicked: saveButtonClicked,
                    fieldSelected: fieldSelected,
                    seekToField: true,
                    showStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                    standardFilterButtonClicked: standardFilterButtonClicked,
                    treeBrowseLevelChanged: treeBrowseLevelChanged
                };
                buildFieldColumnPopupDialog(contents, settings);
            });
        };

        skyward.filterbuilder.getTreeBrowseForFieldToField = function (valueBox)
        {
            const fieldSelectorControl = valueBox.closest(".condition").find(".filterBuilderFieldSelect");
            const fieldSelectorControlData = fieldSelectorControl.data();
            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();
            const conditionValueContainer = valueBox.closest(".conditionValuesContainer");
            const isReportMode = checkIsReportMode(fieldSelectorControl);

            let browseDialog;
            let rootModule;
            let rootObject;
            let relationshipPath;
            let lookupModule;
            let lookupObject;
            let fieldDataType;

            if (fieldSelectorControlData)
            {
                rootModule = filterBuilderData.fieldToFieldRootModule || filterBuilderData.rootModule;
                rootObject = filterBuilderData.fieldToFieldRootObject || filterBuilderData.rootObject;
                relationshipPath = filterBuilderData.fieldToFieldRelationshipPath || filterBuilderData.relationshipPath;
                lookupModule = fieldSelectorControlData.module || rootModule;
                lookupObject = fieldSelectorControlData.object || rootObject;

                if (fieldSelectorControlData.calculatedFieldName)
                {
                    fieldDataType = skyward.reporting.calculatedFields.Get(fieldSelectorControlData.calculatedFieldName).dataType.split(' ')[0];
                }
                else
                {
                    fieldDataType = fieldSelectorControlData.fieldType.split(' ')[0];
                }
            }

            var fieldColumnPopup = function ()
            {
                return $.ajax(skyward.global.virtualDir + filterBuilderData.buildTreeBrowsePath,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data:
                        {
                            lookupModule: lookupModule,
                            lookupObject: lookupObject,
                            rootModule: rootModule,
                            rootObject: rootObject,
                            relationshipPath: relationshipPath,
                            absoluteTreeBrowseObjectPath: relationshipPath,
                            routehash: filterBuilderData.routehash,
                            securitymodule: filterBuilderData.securitymodule,
                            securityobject: filterBuilderData.securityobject,
                            securityscreen: filterBuilderData.securityscreen,
                            mode: fieldSelectorControlData.mode,
                            browseId: filterBuilderData.browseid,
                            renderOneToMany: filterBuilderData.allowOneToManyBrowse,
                            fieldDataType: fieldDataType,
                            allowOneToManyBrowse: filterBuilderData.allowOneToManyBrowse,
                            renderOperationFields: !filterBuilderData.isExistsFilterBuilder,
                            isExistsFilterBuilder: filterBuilderData.isExistsFilterBuilder,
                            isForFieldToField: true,
                            renderCalculatedFieldsPanel: filterBuilderData.includeCalculatedFields,
                        },
                        dataFilter: function (html)
                        {
                            return buildFilterBuilderPopupWrapper(filterBuilderData, html);
                        }
                    });
            };

            var saveButtonClicked = function (_event, dialog)
            {
                let rowData;
                if (isReportMode)
                {
                    rowData = skyward.fieldselectionpanels.getSelectedField(dialog.content);
                }
                else
                {
                    rowData = skyward.treebrowse.getSelectedFieldData(dialog.content);
                }

                selectFieldFromRow(rowData);
            };

            var treeBrowseSave = function (_event, _treeBrowseData, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var fieldSelected = function (_event, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var selectFieldFromRow = function (rowData)
            {
                if (rowData)
                {
                    let fieldData = {};
                    let existPathToUse = null;

                    const allExistPathsToCurrentExist = filterBuilderData.allExistPathsToCurrentExist;
                    if (allExistPathsToCurrentExist && allExistPathsToCurrentExist.length)
                    {
                        //Sort descending by number of relationships
                        allExistPathsToCurrentExist.sort(function (first, second)
                        {
                            const firstLength = first.split(".").length;
                            const secondLength = second.split(".").length;

                            if (firstLength > secondLength)
                            {
                                return -1;
                            }
                            if (firstLength < secondLength)
                            {
                                return 1;
                            }
                            return 0;
                        })

                        if (rowData.absoluteFieldPath)
                        {
                            existPathToUse = allExistPathsToCurrentExist.find(function (existPath) { return rowData.absoluteFieldPath.startsWith(existPath + "."); })
                        }
                    }

                    if (rowData.id)
                    {
                        fieldData =
                        {
                            fieldPath: null,
                            calculatedFieldName: rowData.id,
                            fieldType: rowData.dataType,
                            isCalculatedField: true,
                            isOperation: false,
                            parameters: rowData.parameters
                        };
                    }
                    else if (filterBuilderData.isExistsFilterBuilder === true && existPathToUse)
                    {
                        fieldData =
                        {
                            fieldPath: existPathToUse,
                            fieldName: rowData.absoluteFieldPath.substring(existPathToUse.length + 1),
                            displayName: rowData.displayName,
                            displayPathText: rowData.displayPathText,
                            fieldType: rowData.fieldType,
                            isCalculatedField: false,
                            isOperation: rowData.isOperation,
                            parameters: rowData.parameters,
                            existsPath: existPathToUse,
                            rootModule: filterBuilderData.fieldToFieldRootModule,
                            rootObject: filterBuilderData.fieldToFieldRootObject
                        };
                    }
                    else
                    {
                        fieldData =
                        {
                            fieldPath: rowData.fieldPath,
                            fieldName: rowData.absoluteFieldPath,
                            displayName: rowData.displayName,
                            displayPathText: rowData.displayPathText,
                            fieldType: rowData.fieldType,
                            isCalculatedField: false,
                            isOperation: rowData.isOperation,
                            parameters: rowData.parameters,
                            rootModule: filterBuilderData.fieldToFieldRootModule,
                            rootObject: filterBuilderData.fieldToFieldRootObject
                        };
                    }

                    setConditionSpanValue(conditionValueContainer, rowData.displayPathText, fieldData, rowData.svgClass);
                }

                //There's two popups open at this point so close both
                skyward.window.closePopup();
                skyward.window.closePopup();
            };

            var treeBrowseLevelChanged = function (_event, data)
            {
                const saveButtonTextSpan = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton .modalContentFooter__buttonText");
                const saveButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton");

                if (data.isDataField)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            function fieldColumnPopupTreeBrowse(contents)
            {
                const saveButton =
                {
                    text: "Select Field",
                    click: saveButtonClicked,
                    icon: "Save",
                    additionalClasses: ["filterSaveButton"]
                };
                const cancelButton =
                {
                    text: "Cancel",
                    click: "close",
                    icon: "Cancel"
                };

                const options =
                {
                    animationDuration: 0,
                    draggable: true,
                    closeOnClick: false
                };
                const jqContents = $(contents);
                const buttons = [saveButton, cancelButton];

                skyward.filterbuilder.fieldSelectorDialog = browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);

                browseDialog.content.on("treeBrowseLevelChanged", treeBrowseLevelChanged).on("treeBrowseRowChange", treeBrowseLevelChanged);
                browseDialog.content.on("treeBrowseSave", treeBrowseSave);
                if (filterBuilderData.includeCalculatedFields)
                {
                    browseDialog.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                    {
                        skyward.calculatedFieldList.updateCalculatedFieldList(
                            treeBrowseData,
                            Object.values(skyward.reporting.calculatedFields.AllFieldsOfType(fieldDataType)),
                            undefined,
                            fieldSelectorControlData.rootModule,
                            fieldSelectorControlData.rootObject,
                            fieldSelectorControlData.relationshipPath,
                            filterBuilderData.rootExistsPath
                        );
                    });
                }
            }

            fieldColumnPopup().done(function (contents)
            {
                const settings =
                {
                    buildTreeBrowsePopup: fieldColumnPopupTreeBrowse,
                    fieldDataType: fieldDataType,
                    filterBuilderData: filterBuilderData,
                    fieldSelected: fieldSelected,
                    fieldSelectorControlData: fieldSelectorControlData,
                    isReportMode: isReportMode,
                    saveButtonClicked: saveButtonClicked,
                    seekToField: false,
                    showStandardFilterButton: false,
                    standardFilterClick: undefined,
                    treeBrowseLevelChanged: treeBrowseLevelChanged
                };
                buildFieldColumnPopupDialog(contents, settings);
            });
        };

        var buildFilterBuilderPopupWrapper = function (filterBuilderData, html)
        {
            if (filterBuilderData.wrapperClassName)
            {
                return `<div class='${filterBuilderData.wrapperClassName}'>${html}</div>`;
            }
            else
            {
                return `<div style='max-height: 500px;'>${html}</div>`;
            }
        };

        var setConditionSpanValue = skyward.filterbuilder.setConditionSpanValue = function (conditionValuesContainer, displayValue, data, svgClass, triggerChange)
        {
            var input = conditionValuesContainer.find(".js-valueConditionValue");
            var span = conditionValuesContainer.find(".js-bindingConditionValue");

            triggerChange = (triggerChange == undefined) ? true : triggerChange;

            //reset the span and input
            span.setAllDataToNull();
            span.text("");
            span.removeClass("hidden");
            span.addClass("js-conditionValue--active");
            if (input.length)
            {
                skyward.controls.hide(input, false);
                input.removeClass("js-conditionValue--active");
                skyward.controls.clearValue(input);

                span.on('click', function () { hideConditionValueSpan($(this)); });
            }

            if (data.fieldType && data.fieldType.indexOf("Enum") >= 0)
            {
                data.enumType = data.fieldType;
            }

            span.data(data);
            span.text(displayValue);
            if (svgClass)
            {
                var svg = skyward.svg.getSvg(svgClass, "TreeBrowse");
                var svgHolder = makeSvgHolder();
                svgHolder.html(svg);
                span.prepend(svgHolder);
            }

            if (triggerChange)
            {
                span.trigger("change");
            }

            updateFriendlyQuery();
        };

        function buildFieldSelectorData(rowData)
        {
            let data =
            {
                module: rowData.fieldModule,
                object: rowData.fieldObject,
                field: undefined,
                fieldPath: undefined,
                absoluteFieldPath: undefined,
                fieldType: undefined,
                displayName: rowData.displayName,
                displayPathText: rowData.displayPathText,
                selectedFieldRelationshipPath: undefined,
                calculatedFieldName: undefined,
                isCalculated: false,
                isOperation: rowData.isOperation,
                parameters: rowData.parameters
            };

            if (rowData.isCalculatedField)
            {
                data.calculatedFieldName = rowData.id;
                data.fieldType = rowData.fieldType;
                data.isCalculated = true;
            }
            else if (rowData.isRelationship)
            {
                data.field = rowData.relationshipName;
                data.fieldPath = rowData.relationshipPath,
                data.fieldType = rowData.fieldType;
                data.absoluteFieldPath = rowData.relationshipPath;
                data.selectedFieldRelationshipPath = rowData.relationshipPath ?? "";
            }
            else
            {
                const lasIndexOfDot = rowData.absoluteFieldPath.lastIndexOf('.');
                const fieldName = rowData.absoluteFieldPath.substring(lasIndexOfDot + 1);

                data.field = fieldName;
                data.fieldPath = rowData.fieldName, // {Root Object Name}.{Absolute Field Path}
                data.absoluteFieldPath = rowData.absoluteFieldPath;
                data.fieldType = rowData.format ?? rowData.fieldType,
                data.selectedFieldRelationshipPath = rowData.relationshipPath ?? ""; // Entire relationship path from Root Object to Field
            }

            return data;
        }

        var updateFieldSelector = function (fieldSelectorControl, rowData)
        {
            fieldSelectorControl.data(buildFieldSelectorData(rowData));
            fieldSelectorControl.find("span").html(rowData.displayPathText);
            fieldSelectorControl.removeClass("active");
            fieldSelectorControl.parent().find(".conditionValuesContainer, .conditionRangeValuesWrapper").remove();

            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();

            $.ajax({
                url: skyward.global.virtualDir + "SkySys/Filter/GetConditionTypeComboBox",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    fieldType: rowData.isCalculatedField ? rowData.fieldType : (rowData.format ?? rowData.fieldType),
                    absoluteFieldPath: rowData.absoluteFieldPath,
                    rootModule: filterBuilderData.rootModule,
                    rootObject: filterBuilderData.rootObject,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    routehash: filterBuilderData.routehash,
                    includeList: rowData.id == null
                },
                success: function (data)
                {
                    const conditionTypesComboBox = fieldSelectorControl.siblings(".conditionTypesComboBox");
                    const newComboBox = $(data);
                    if (conditionTypesComboBox.length > 0)
                    {
                        conditionTypesComboBox.replaceWith(newComboBox);
                    }
                    else
                    {
                        $(newComboBox).insertAfter(fieldSelectorControl);
                    }
                    updateFriendlyQuery();
                    const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                    skyward.window.notifyDOMLoad(selector);
                    if (rowData.triggerType === "exists")
                    {
                        newComboBox.val("Exists");
                        newComboBox.change();
                    }
                    else if (rowData.triggerType === "notExists")
                    {
                        newComboBox.val("NotExists");
                        newComboBox.change();
                    }
                }
            });
        };

        var makeSvgHolder = function ()
        {
            return $("<span/>").addClass("svgHolder");
        };

        var getValueControl = function ()
        {
            const combo = $(this);
            combo.find(".placeholder").remove();
            combo.removeClass("active");

            const filterBuilderData = combo.closest(".filterBuilder").data();

            const conditionType = combo.val();

            const getValueControls = conditionType.indexOf("Null") < 0 && conditionType.indexOf("True") < 0 && conditionType.indexOf("False") < 0;
            if (getValueControls)
            {
                const fieldSelectData = combo.siblings(".filterBuilderFieldSelect").first().data();
                const postdata =
                {
                    conditionType: conditionType,
                    fieldType: fieldSelectData.fieldType,
                    absoluteFieldPath: fieldSelectData.absoluteFieldPath,
                    rootobject: fieldSelectData.rootObject,
                    rootmodule: fieldSelectData.rootModule,
                    routehash: filterBuilderData.routehash,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    applyDistrictEntityFilter: filterBuilderData.applyDistrictEntityFilter,
                    fieldToFieldRootModule: filterBuilderData.fieldToFieldRootModule,
                    fieldToFieldRootObject: filterBuilderData.fieldToFieldRootObject,
                    fieldToFieldRelationshipPath: filterBuilderData.fieldToFieldRelationshipPath,
                    rootExistsPath: filterBuilderData.rootExistsPath,
                    allExistPathsToCurrentExist: JSON.stringify(filterBuilderData.allExistPathsToCurrentExist),
                    districtVariables: JSON.stringify(filterBuilderData.districtVariables),
                    applyFiscalYearOrSchoolYearFilterToValueControl: filterBuilderData.applyFiscalYearOrSchoolYearFilterToValueControl,
                    saveEnvironmentVariablesAsBindings: filterBuilderData.saveEnvironmentVariablesAsBindings,
                    includeStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                    includeCalculatedFields: filterBuilderData.includeCalculatedFields,
                    calculatedFields: JSON.stringify(skyward.reporting.calculatedFields.Get(fieldSelectData.calculatedFieldName)),
                    importID: filterBuilderData.importId,
                    sectionID: filterBuilderData.sectionId
                };

                $.ajax({
                    url: skyward.global.virtualDir + filterBuilderData.getValueControlAction,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: postdata,
                    success: function (data)
                    {
                        const valueDiv = $(data);
                        combo.parent().find(".conditionValuesContainer").remove();
                        combo.parent().find(".conditionRangeValuesWrapper").remove();
                        valueDiv.insertAfter(combo);
                        const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                        skyward.window.notifyDOMLoad(selector);
                        valueDiv.find(".addEnvironmentVariableButton").each(function ()
                        {
                            const environmentVariableLauncher = $(this);
                            environmentVariableLauncher.on("click", showEnvironmentVariables);
                        });
                    }
                });
            }
            else
            {
                combo.parent().find(".conditionValuesContainer").remove();
                combo.parent().find(".conditionRangeValuesWrapper").remove();
            }
            updateFriendlyQuery();
        };

        var updateDistrictEntityFilter = function ()
        {
            var checkbox = $(this);
            var isChecked = checkbox.is(":checked");
            skyward.filterbuilder.originalPopupButton.data("applyDistrictEntityFilter", isChecked);
            checkbox.closest(".fieldWrapper").siblings(".hideWhenUnchecked").toggle(isChecked);
            updateFriendlyQuery();
        };

        var getEnvironmentVariableElements = function (button)
        {
            var result =
            {
                shown: button.parent().find(".environmentVariablesContainer, .environmentVariablesContainer .environmentVariablesCombo, .removeEnvironmentVariableButton"),
                // TODO: Remove datepicker-trigger & datepicker-wrapper in PR 6145635
                hidden: button.parent().find("js-valueConditionValue, .datepicker-trigger, .datepicker-wrapper, sky-datepicker, .addEnvironmentVariableButton")
            };
            return result;
        };

        var hideEnvironmentVariables = function ()
        {
            var elements = getEnvironmentVariableElements($(this));
            elements.shown.addClass("hidden");
            elements.hidden.removeClass("hidden");
            var selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
            skyward.window.notifyDOMLoad(selector);
        };

        var showEnvironmentVariables = function ()
        {
            var elements = getEnvironmentVariableElements($(this));
            elements.hidden.addClass("hidden");
            elements.shown.removeClass("hidden");
            var selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
            skyward.window.notifyDOMLoad(selector);
        };

        var getFilterBuilderFromServer = function (removeInvalidFields, popupButton)
        {
            if (popupButton.hasClass("ui-disabled"))
            {
                return;
            }

            const popupButtonData = popupButton.data();
            const filterValueInput = popupButton.siblings(".filterViewValue");
            const filterCondition = filterValueInput.data("filterCondition");
            const isReportMode = checkIsReportMode(popupButton);
            const includeCalculatedFields = isReportMode && popupButtonData.includeCalculatedFields;

            let allExistPathsToCurrentExist = [];
            if (popupButtonData.allExistPathsToCurrentExist && popupButtonData.allExistPathsToCurrentExist.length)
            {
                // copy array to prevent updating popupButtonData when allExistPathsToCurrentExist is updated
                allExistPathsToCurrentExist = Array.from(popupButtonData.allExistPathsToCurrentExist);
            }
            if (popupButtonData.rootExistsPath)
            {
                allExistPathsToCurrentExist.push(popupButtonData.rootExistsPath);
            }

            let postData =
            {
                importID: popupButtonData.importId,
                sectionID: popupButtonData.sectionId,
                lookupModule: popupButtonData.module,
                lookupObject: popupButtonData.object,
                rootModule: popupButtonData.rootModule,
                rootObject: popupButtonData.rootObject,
                relationshipPath: popupButtonData.relationshipPath,
                filterCondition: skyward.extensions.encodeHtml(typeof filterCondition === "object" ? JSON.stringify(filterCondition) : filterCondition),
                routeHash: popupButtonData.routehash,
                includeStandardFilterButton: popupButtonData.includeStandardFilterButton,
                securitymodule: popupButtonData.securitymodule,
                securityobject: popupButtonData.securityobject,
                securityscreen: popupButtonData.securityscreen,
                removeInvalidFields: removeInvalidFields,
                browseId: popupButtonData.browseId,
                applyDistrictEntityFilter: popupButtonData.applyDistrictEntityFilter,
                allowOneToManyBrowse: popupButtonData.allowOneToManyBrowse,
                fieldToFieldRootModule: popupButtonData.fieldToFieldRootModule,
                fieldToFieldRootObject: popupButtonData.fieldToFieldRootObject,
                fieldToFieldRelationshipPath: popupButtonData.fieldToFieldRelationshipPath,
                rootExistsPath: popupButtonData.rootExistsPath,
                allExistPathsToCurrentExist: JSON.stringify(allExistPathsToCurrentExist),
                isExistsFilterBuilder: popupButtonData.isExistsFilterBuilder,
                districtVariables: JSON.stringify(popupButtonData.districtVariables),
                applyFiscalYearOrSchoolYearFilterToValueControl: popupButtonData.applyFiscalYearOrSchoolYearFilterToValueControl,
                saveEnvironmentVariablesAsBindings: popupButtonData.saveEnvironmentVariablesAsBindings,
                includeCalculatedFields: includeCalculatedFields,
            };

            if (isReportMode)
            {
                if (includeCalculatedFields)
                {
                    postData.calculatedFields = JSON.stringify(skyward.reporting.calculatedFields.AllFields());
                }
                postData.reportPrompts = skyward.reporting.prompts.promptCollection.toJsonString();
            }

            $.ajax({
                url: skyward.global.virtualDir + popupButtonData.actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    const modalTitle = "Filter Builder";
                    const dialog = skyward.modalLayer.showDialog(modalTitle, data.html, getFilterBuilderButtons(data.invalidFields, popupButton), { width: (skyward.window.clientWidth * .95), draggable: true, closeOnClick: false });
                    $.when(dialog.bodyPromise).then(function ()
                    {
                        const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                        skyward.window.notifyDOMLoad(selector);
                        dialog.animateModalContents();
                        filterBuilderDialogs.register(dialog);
                        updateFriendlyQuery();
                    });
                    if (skyward.filterbuilder.originalPopupButton == popupButton)
                    {
                        dialog.modalLayer.beforeClose = function (layer, reason)
                        {
                            if (reason !== "removeInvalidFields")
                            {
                                skyward.filterbuilder.originalPopupButton = null;
                            }
                        };
                    }
                    return data;
                }
            });
        };

        var getFilterBuilderButtons = function (invalidFields, popupButton)
        {
            let buttons = [];

            if (!invalidFields)
            {
                buttons.push({
                    text: "Save",
                    icon: "Save",
                    "click": function ()
                    {
                        const button = $(this);
                        if (!button.hasClass("ui-disabled"))
                        {
                            const searchCondition = buildNewSearchCondition();

                            const validationMessage = searchCondition.getValidationMessage();
                            if (validationMessage)
                            {
                                skyward.modalLayer.showDialog("Invalid Filter", validationMessage, [{ text: "Close", icon: "Close" }]);
                            }
                            else
                            {
                                updateFilter(popupButton, searchCondition, $(this));
                            }
                        }
                    }
                });
            }
            else
            {
                buttons.push({
                    text: "Remove Invalid Fields",
                    icon: "Delete",
                    "click": function (e, dialog)
                    {
                        filterBuilderDialogs.closeCurrent();
                        getFilterBuilderFromServer(true, popupButton);
                    }
                });
            }

            buttons.push({ text: "Cancel", icon: "Cancel", click: filterBuilderDialogs.closeCurrent });
            return buttons;
        };

        skyward.filterbuilder.showFilter = function (event)
        {
            const popupButton = $(event.target);
            if (!skyward.filterbuilder.originalPopupButton)
            {
                skyward.filterbuilder.originalPopupButton = popupButton;
            }

            getFilterBuilderFromServer(false, popupButton);
        };

        skyward.filterbuilder.updateFilter = function (popupButton, newSearchCondition)
        {
            updateFilter(popupButton, newSearchCondition);
        };

        function updateFilter(popupButton, newSearchCondition, clickedSaveButton)
        {
            var filterBuilderDialog = filterBuilderDialogs.getCurrent();
            var popupButtonData = popupButton.data();
            var filterValueInput = popupButton.siblings(".filterViewValue");
            var oldSearchCondition = filterValueInput.data("filterCondition");
            var oldSearchConditionJSON = oldSearchCondition ? skyward.extensions.encodeHtml(typeof oldSearchCondition === "object" ? JSON.stringify(oldSearchCondition) : oldSearchCondition) : "";
            var newSearchConditionJSON = newSearchCondition ? newSearchCondition.toJSON() : "null";

            var filterBuilderData = popupButtonData;

            if (clickedSaveButton)
            {
                clickedSaveButton.addClass("ui-disabled");
                filterBuilderData = filterBuilderDialog.content.find(".filterBuilder").data();
            }

            if (popupButtonData.isExistsFilterBuilder)
            {
                updateFilterSucess({
                    conditionChanged: newSearchConditionJSON !== oldSearchConditionJSON,
                    filterCondition: newSearchConditionJSON

                }, popupButton, clickedSaveButton);
            }
            else
            {
                $.ajax({
                    url: skyward.global.virtualDir + "SkySys/Filter/GetSearchConditionXml",
                    type: "POST",
                    datatype: "JSON",
                    data:
                    {
                        newFilterCondition: newSearchConditionJSON,
                        oldFilterCondition: oldSearchConditionJSON,
                        routehash: filterBuilderData.routehash,
                        securitymodule: filterBuilderData.securitymodule,
                        securityobject: filterBuilderData.securityobject,
                        securityscreen: filterBuilderData.securityscreen,
                        districtVariables: JSON.stringify(filterBuilderData.districtVariables),
                        saveEnvironmentVariablesAsBindings: filterBuilderData.saveEnvironmentVariablesAsBindings
                    },
                    success: function (data)
                    {
                        updateFilterSucess(data, popupButton, clickedSaveButton);
                    },
                    error: function ()
                    {
                        if (clickedSaveButton)
                        {
                            clickedSaveButton.removeClass("ui-disabled");
                        }
                    }
                });
            }
        }

        function updateFilterSucess(data, popupButton, clickedSaveButton)
        {
            const filterBuilderDialog = filterBuilderDialogs.getCurrent();
            const filterValueInput = popupButton.siblings(".filterViewValue");
            const isReportMode = checkIsReportMode(popupButton);
            let filterCondition = null;

            if (clickedSaveButton)
            {
                filterBuilderDialogs.closeCurrent();
            }
            if (data.conditionChanged)
            {
                if (data.filterCondition)
                {
                    filterCondition = JSON.parse(data.filterCondition);
                }

                if (data.parameters)
                {
                    filterValueInput.data("parameters", data.parameters);
                }

                if (data.filterSchemaFields)
                {
                    filterValueInput.data("filterSchemaFields", data.filterSchemaFields);
                }

                filterValueInput.data("filterCondition", filterCondition);

                if (!filterCondition)
                {
                    popupButton.removeClass("hasFilterCondition").addClass("noFilterCondition");
                }
                else
                {
                    popupButton.removeClass("noFilterCondition").addClass("hasFilterCondition");
                }

                const searchCondition = skyward.searchCondition.getFromJson(data.filterCondition, convertBindingsToFriendlyNames);
                const friendlyQuery = searchCondition.toFriendlyQuery();

                if (clickedSaveButton) //this was an exists condition filter builder, it's filter viewer needs to be updated, and the subsequent filter builder needs to update.
                {
                    popupButton.siblings(".filterViewerDisplay").val(friendlyQuery).trigger('change');
                }
                else if (filterBuilderDialog) //the section filter was modified, the current filter builders' friendly query needs to be updated
                {
                    filterBuilderDialog.content.find(".currentQuery div").html(friendlyQuery);
                }

                const hidden = popupButton.siblings(".filterViewValue");

                hidden.attr("value", data.searchConditionXml?.toString() ?? "");

                //The Prompt Details Dialog relies on the hidden input triggering a change when the filter changes.
                //It then looks to the JSON to get the new filter so it doesn't matter if we have XML or not.
                hidden.change();
            }

            if (isReportMode && clickedSaveButton)
            {
                skyward.reporting.onFilterBuilderSave(data);
            }
        }

        var extractNewCondition = function (conditionContainer)
        {
            const condition = new skyward.searchCondition.SearchCondition();

            const conditionComboBox = conditionContainer.find(".conditionTypesComboBox");
            const operandInputs = conditionContainer.find(".js-conditionValue--active");
            const fieldSelector = conditionContainer.find(".filterBuilderFieldSelect");
            const conditionComboBoxData = conditionComboBox.data();
            const fieldSelectorData = fieldSelector.data();

            const isRestricted = fieldSelectorData.isRestricted;
            if (isRestricted)
            {
                condition.IsRestricted = isRestricted;
            }

            let type = skyward.searchCondition.getSearchConditionTypeByFieldType(fieldSelectorData.fieldType);

            if (type === skyward.searchCondition.Types.TypedStandardFilterSearchCondition)
            {
                condition.setType(type);
                condition.set({
                    DataObjectType: fieldSelectorData.dataObjectFullName,
                    RelationshipPath: fieldSelectorData.standardFilterRelationshipPath,
                    DisplayName: fieldSelector.find("span").text(),
                    SkywardID: fieldSelectorData.standardFilterId,
                    PromptUniqueId: operandInputs.data("promptUniqueId")
                });

                return condition;
            }

            if (!conditionComboBoxData)
            {
                return null;
            }

            if (conditionComboBoxData.interfaceName)
            {
                condition.setType(skyward.searchCondition.Types.SchemaObjectFilterSearchCondition);
                condition.set({
                    DataObjectType: fieldSelectorData.dataObjectFullName,
                    RelationshipPath: fieldSelectorData.relationshipPath,
                    InterfaceName: conditionComboBoxData.interfaceName,
                    DisplayName: conditionComboBoxData.displayName
                });
                return condition;
            }

            const fieldName = fieldSelectorData.absoluteFieldPath;
            const fieldPath = fieldSelectorData.fieldPath;
            const fieldType = fieldSelectorData.fieldType;
            const displayName = fieldSelectorData.displayName;
            const displayPath = fieldSelectorData.displayPathText;
            const isOperation = fieldSelectorData.isOperation;
            const conditionType = conditionComboBox.val();

            let isRange = false;
            let lowOperandInput = null;
            let lowOperandInputData = null;
            let highOperandInput = null;

            if (operandInputs.length >= 1)
            {
                lowOperandInput = operandInputs.first();
                lowOperandInputData = lowOperandInput.data();

                if (lowOperandInputData.fieldName || lowOperandInputData.calculatedFieldName)
                {
                    type = skyward.searchCondition.Types.FieldToFieldSearchCondition;
                }
                else if (operandInputs.length === 1 && lowOperandInputData.fieldType && lowOperandInputData.fieldType !== fieldSelectorData.fieldType)
                {
                    type = skyward.searchCondition.getSearchConditionTypeByFieldType(lowOperandInputData.fieldType);
                }
            }

            if (operandInputs.length === 2)
            {
                isRange = true;
                highOperandInput = operandInputs.last();
            }

            condition.setType(type);

            condition.set({
                DataObjectType: fieldSelectorData.dataObjectFullName,
                ConditionType: conditionType,
                CalculatedFieldName: fieldSelectorData.calculatedFieldName,
                Parameters: fieldSelectorData.parameters
            });

            if (type === skyward.searchCondition.Types.FieldToFieldSearchCondition)
            {
                condition.set({ LeftFieldName: fieldName, LeftFieldPath: fieldPath, LeftFieldNameDisplay: displayName, LeftFieldPathDisplay: displayPath, LeftFieldType: fieldType, LeftFieldIsOperation: isOperation });

                if (fieldSelectorData.fieldType.toLowerCase() === skyward.searchCondition.FieldTypes.Time)
                {
                    condition.set({ FieldConversionComparisonType: "Time" });
                }
                else if (fieldSelectorData.fieldType.toLowerCase() === skyward.searchCondition.FieldTypes.DateTime)
                {
                    condition.set({ FieldConversionComparisonType: "Date" });
                }
            }
            else if (type === skyward.searchCondition.Types.ExistsSearchCondition)
            {
                condition.set({ RelationshipName: fieldName });
            }
            else
            {
                condition.set({ FieldName: fieldName, FieldPath: fieldPath, FieldNameDisplay: displayName, FieldPathDisplay: displayPath, FieldType: fieldType, FieldIsOperation: isOperation });
            }

            if (type === skyward.searchCondition.Types.DateTimeSearchCondition && fieldSelectorData.fieldType.toLowerCase() === skyward.searchCondition.FieldTypes.Time)
            {
                condition.set({ ComparisonType: "CompareTimeOnly" });
            }
            else if (type === skyward.searchCondition.Types.DateTimeSearchCondition)
            {
                condition.set({ ComparisonType: "CompareDateOnly" });
            }

            if (lowOperandInput)
            {
                let lowOperandData;

                if (conditionType.indexOf("Exists") >= 0)
                {
                    lowOperandData = getExistsOperandData(lowOperandInput);
                }
                else if (conditionType.indexOf("List") >= 0)
                {
                    lowOperandData = getListOperandData(lowOperandInput);
                }
                else
                {
                    lowOperandData = getOperandData(lowOperandInput, isRange ? "Low" : "Value");
                }

                if (lowOperandData)
                {
                    condition.set(lowOperandData);
                }
            }

            if (highOperandInput)
            {
                const highOperandData = getOperandData(highOperandInput, "High");
                if (highOperandData)
                {
                    condition.set({ HighType: highOperandData.fieldType });
                    condition.set(highOperandData);
                }
            }

            return condition;
        };

        var getExistsOperandData = function (operandInput)
        {
            var operandData = {};
            var existsFilterLaunchButton = operandInput.find('.filterBuilderLaunchButton');

            var filterValueInput = existsFilterLaunchButton.siblings(".filterViewValue");
            var existsCondition = filterValueInput.data("filterCondition");

            if (existsCondition && typeof (existsCondition) === "object")
            {
                operandData.Condition = existsCondition;
            }
            else
            {
                return null;
            }

            return operandData;
        };

        var getListOperandData = function (operandElement)
        {
            const operandData = {};
            const operandElementData = operandElement.data();
            if (operandElementData.promptUniqueId)
            {
                operandData.ListBinding = "{_prompt." + operandElementData.promptUniqueId + "}";
                return operandData;
            }

            if (operandElementData.environmentVariableBinding)
            {
                operandData.ListBinding = operandElementData.environmentVariableBinding;
                return operandData;
            }

            operandData.List = { Value: [] };

            if (operandElement.hasClass("distinctMultiSelectEEL"))
            {
                const backingData = operandElement.children(".dmsBackingData");
                const values = skyward.controls.getValue(backingData);

                $.each(values, function (key, value)
                {
                    //using key for values such as datetime where the value we push to the list needs to be in a specific format
                    const trimmedKeyValue = key.trim();
                    if (trimmedKeyValue.length)
                    {
                        operandData.List.Value.push(trimmedKeyValue);
                    }
                });

            }
            else // Enum lists are unique in that they have no backing input - their data is stored in span.data("List")
            {
                // Note the change from lowercase to caps. jQuery.data() always makes first letter lowercase, but the property name in C# is "List"
                operandData.List.Value = Array.isArray((operandElementData.list || {}).Value) ? operandElementData.list.Value : [];
            }

            return operandData;
        };

        var getOperandData = function (operandInput, valueKey)
        {
            let operandData = {};
            const operandInputData = operandInput.data();

            if (operandInput.hasClass("enumOptions"))
            {
                operandData.Value = operandInputData.environmentVariableBinding || operandInputData.promptUniqueId || skyward.controls.getValueToString(operandInput);
                return operandData;
            }

            if (operandInputData.enumCodeValue)
            {
                operandData.Value = operandInputData.enumCodeValue;
                return operandData;
            }

            if (operandInputData.enumValue)
            {
                // fall back to enumValue for those enums with empty string codes
                operandData.Value = operandInputData.enumValue;
                return operandData;
            }

            if (typeof operandInputData.boolvalue === "boolean")
            {
                operandData.Value = operandInputData.boolvalue;
                return operandData;
            }

            if (operandInputData.environmentVariableBinding)
            {
                operandData[valueKey + "Binding"] = operandInputData.environmentVariableBinding;
                return operandData;
            }

            if (operandInputData.promptUniqueId)
            {
                operandData[valueKey + "Binding"] = "{_prompt." + operandInputData.promptUniqueId + "}";
                return operandData;
            }

            if (operandInputData.fieldName)
            {
                operandData.RightFieldName = operandInputData.fieldName;
                operandData.RightFieldPath = operandInputData.fieldPath;
                operandData.RightFieldPathDisplay = operandInputData.displayPathText;
                operandData.RightFieldNameDisplay = operandInputData.displayName;
                operandData.RightFieldType = operandInputData.fieldType;
                operandData.RightFieldIsOperation = operandInputData.isOperation;
                operandData.RightFieldExistsPath = operandInputData.existsPath;
                if (operandInputData.rootModule && operandInputData.rootObject)
                {
                    if (operandData.RightFieldExistsPath)
                    {
                        operandData.RightFieldExistsBaseType = operandInputData.rootModule + '.' + operandInputData.rootObject;
                    }
                    else
                    {
                        operandData.RightFieldBaseType = operandInputData.rootModule + '.' + operandInputData.rootObject;
                    }
                }
                return operandData;
            }

            if (operandInputData.calculatedFieldName)
            {
                operandData.RightCalculatedFieldName = operandInputData.calculatedFieldName;
                return operandData;
            }

            if (operandInputData.binding)
            {
                operandData[valueKey + "Binding"] = operandInputData.binding;
                return operandData;
            }

            operandData[valueKey] = skyward.controls.getValueToString(operandInput);

            return operandData;
        };

        var extractSchemaObjectSearchConditions = function (container)
        {
            var conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.set({ ConditionGroupType: "And" });
            conditionGroup.ConvertBindingToDisplayName = convertBindingsToFriendlyNames; // This is copied to all child condition so it only needs to be set here

            var hasSchemaObjectSearchConditions = false;
            container.children(".schemaObjectFilter:has(.checkbox:checked)").each(function ()
            {
                var conditionContainer = $(this).find(".condition");
                var condition = extractNewCondition(conditionContainer);

                if (condition)
                {
                    conditionGroup.addCondition(condition);
                    hasSchemaObjectSearchConditions = true;
                }
            });

            if (hasSchemaObjectSearchConditions)
            {
                return conditionGroup;
            }

            return null;
        };

        // this is only used to extract the condition to display the friendly query, it is not saved with the condition
        // if district entity filters ever contain groups, this won't work (along with many other things)
        var extractNewDistrictEntityFilter = function (container)
        {
            if (container.length === 0 || !container.is(":visible"))
            {
                return null;
            }

            if (!container.find(".applyDistrictEntityFilter").is(":checked"))
            {
                return null;
            }

            var conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.ConvertBindingToDisplayName = convertBindingsToFriendlyNames; // This is copied to and child condition so it only needs to be set here
            conditionGroup.set({ ConditionGroupType: "And" });

            container.children(".condition").each(function ()
            {
                var childConditionContainer = $(this);

                var condition = new skyward.searchCondition.SearchCondition();
                let conditionType = childConditionContainer.find(".windowSearchConditionConditionType").val();

                condition.set({ ConditionType: conditionType });

                let fieldName = childConditionContainer.find(".windowSearchConditionFieldName").data("fieldName");
                let operandInput = childConditionContainer.find(".js-conditionValue--active");

                if (conditionType == "Exists")
                {
                    condition.set({ RelationshipName: fieldName });
                    condition.set(getExistsOperandData(operandInput));
                }
                else
                {
                    condition.set({
                        FieldName: fieldName,
                        ValueBinding: operandInput.data("environmentVariableBinding")
                    });
                }

                conditionGroup.addCondition(condition);
            });

            return conditionGroup;
        };

        var extractNewConditionGroup = function (container)
        {
            let conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.set({ ConditionGroupType: container.children(".conditionGroupControlsContainer").find("input:radio:checked").val() || "And" });
            conditionGroup.ConvertBindingToDisplayName = convertBindingsToFriendlyNames; // This is copied to and child condition so it only needs to be set here

            const children = Array.from(container.children(".condition, .conditionGroup"));
            const conditionCount = children.filter(el => el.classList.contains("condition")).length;
            const conditionGroupCount = children.filter(el => el.classList.contains("conditionGroup")).length;

            for (let i = 0; i < children.length; i++)
            {
                const childConditionContainer = $(children[i]);
                if (childConditionContainer.hasClass("condition"))
                {
                    const childCondition = extractNewCondition(childConditionContainer);
                    if (childCondition)
                    {
                        if (conditionCount === 1 && conditionGroupCount === 0)
                        {
                            // just return the condition itself instead of as a conditionGroup
                            return childCondition;
                        }
                        conditionGroup.addCondition(childCondition);
                    }
                }
                else
                {
                    const childCondition = extractNewConditionGroup(childConditionContainer);
                    if (childCondition)
                    {
                        conditionGroup.addCondition(childCondition);
                    }
                }
            }
            return conditionGroup;
        };

        var buildNewSearchCondition = skyward.filterbuilder.buildNewSearchCondition = function ()
        {
            const container = filterBuilderDialogs.getCurrent().content.find(".filterBuilder > .conditionsContainer");

            const searchCondition = extractNewConditionGroup(container);
            const schemaObjectFilterConditions = extractSchemaObjectSearchConditions(container);

            if (schemaObjectFilterConditions)
            {
                // the main search condition will always be an "And" condition so we can add it to it directly
                searchCondition.addCondition(schemaObjectFilterConditions);
            }

            return searchCondition;
        };

        var reparentFilterBuilder = function (filterViewerContainer, selectedValueInput, resetFilterBuilder)
        {
            if (resetFilterBuilder && (selectedValueInput.is('[disabled],[readonly],.ui-disabled') || selectedValueInput.parent().is('[disabled],[readonly],.ui-disabled')))
            {
                return;
            }

            var module = selectedValueInput.data("filterbuilder-module");
            var object = selectedValueInput.data("filterbuilder-object");

            if (module && object)
            {
                if (resetFilterBuilder === true)
                {
                    var filterViewValue = filterViewerContainer.find('.filterViewValue');
                    filterViewValue.val("");
                    filterViewValue.data("filterCondition", {});
                    filterViewValue.change();
                }

                var button = filterViewerContainer.find(".filterBuilderLaunchButton");

                button.data("module", module);
                button.data("object", object);
                button.data("rootModule", module);
                button.data("rootObject", object);
            }
        };

        var reparentFilterBuilderFromCodeEEL = function (filterContainer, moduleNameInput, objectNameInput, clearValue)
        {
            var module = moduleNameInput.val();
            var object = objectNameInput.val();

            if (clearValue)
            {
                var filterViewValue = filterContainer.find('.filterViewValue');
                filterViewValue.val("");
                filterViewValue.data("filterCondition", {});
                filterViewValue.change();
            }

            var launchButton = filterContainer.find(".filterBuilderLaunchButton");

            launchButton.data("module", module);
            launchButton.data("object", object);
            launchButton.data("rootModule", module);
            launchButton.data("rootObject", object);
        };

        var setupCodeEELReparenting = function (selector, objectCodeEELID, moduleCodeEELID)
        {
            var objectCodeEEL = $('#' + objectCodeEELID);
            var moduleCodeEEL = $('#' + moduleCodeEELID);
            var filterContainer = $(selector + " .filterContainer");

            if (objectCodeEEL.length === 1 && moduleCodeEEL.length === 1)
            {
                var moduleNameInput = moduleCodeEEL.find('.codeEELCode');
                var objectNameInput = objectCodeEEL.find('.codeEELCode');

                reparentFilterBuilderFromCodeEEL(filterContainer, moduleNameInput, objectNameInput, false);

                var onChangeAction = function ()
                {
                    reparentFilterBuilderFromCodeEEL(filterContainer, moduleNameInput, objectNameInput, true);
                };

                objectCodeEEL.on('eelComplete', onChangeAction);
                moduleCodeEEL.on('eelComplete', onChangeAction);
            }
        };

        var setupReparentingOnInputChange = function (selector, reparenterInputClass)
        {
            var reparenterInput = $(selector + " ." + reparenterInputClass);
            var getSelectedValueFunction;
            var changeEvent;

            if (reparenterInput.hasClass("radioButtonGroup"))
            {
                getSelectedValueFunction = function (parentInput)
                {
                    return parentInput.find("input:checked").parent();
                };
                changeEvent = "click";
            }
            else if (reparenterInput.hasClass("comboBoxSet"))
            {
                getSelectedValueFunction = function (parentInput)
                {
                    return parentInput.find("option:selected");
                };
                changeEvent = "change";
            }

            if (getSelectedValueFunction && changeEvent)
            {
                reparentFilterBuilder($(selector + " .filterContainer"), getSelectedValueFunction(reparenterInput), false);
                reparenterInput.on(changeEvent, function ()
                {
                    reparentFilterBuilder($(selector + " .filterContainer"), getSelectedValueFunction($(this)), true);
                });
            }
        };

        skyward.filterbuilder.getFilterValueSelectorData = function (button, searchField, conditionType, dataModule, dataObject)
        {
            var conditionValuesContainer = $(button).closest(".conditionValuesContainer");
            var input = conditionValuesContainer.find("input");
            var valueBox = conditionValuesContainer.find(".js-conditionValue--active");
            var valueBoxData = valueBox.data();

            var result =
            {
                postData:
                {
                    moduleName: dataModule,
                    objectName: dataObject,
                    fieldName: searchField,
                    conditionType: conditionType,
                    selectedValues: valueBoxData.list ? valueBoxData.list.Value : [],
                    inputName: input.attr('name')
                },
                valueBox: valueBox
            };

            return result;
        };

        skyward.filterbuilder.getFilterValueSelector = function (button, searchField, conditionType, dataModule, dataObject)
        {
            var filterValueSelectorData = skyward.filterbuilder.getFilterValueSelectorData(button, searchField, conditionType, dataModule, dataObject);

            $.ajax({
                url: skyward.global.virtualDir + "SkySys/Filter/GetValueSelector",
                type: "POST",
                dataType: "JSON",
                data: filterValueSelectorData.postData,
                success: function (data)
                {
                    skyward.filterbuilder.openValueSelector(data.html, button, filterValueSelectorData.valueBox, data.isListOfEnums);
                }

            });
        };

        skyward.filterbuilder.openValueSelector = function (html, button, valueBox, isListOfEnums, treatPromptAsInUse, clickEvents)
        {
            if (treatPromptAsInUse === undefined)
            {
                treatPromptAsInUse = true;
            }
            var valueBoxData = valueBox.data();
            var conditionValueContainer = valueBox.closest('.conditionValuesContainer');

            conditionValueContainer.find('input').on('workflowEnd', function (e, data)
            {
                setFilterValue({ binding: data.additionalValues.FilterValueBinding, name: data.additionalValues.FilterValueName });
            });

            var dropdown = $(html);
            var menu;
            var dialogOptions =
            {
                closeOnClick: true,
                closeOnEscape: true,
                closeOnGlassClick: true,
                anchorTo: button,
                beforeClose: dropdown.remove
            };

            if (isListOfEnums)
            {
                var buttons = [
                    {
                        text: "Save",
                        click: function ()
                        {
                            setFilterValue(getSelectedItems());
                            menu.close();
                        },
                        icon: "Save"
                    },
                    {
                        text: "Cancel",
                        click: function ()
                        {
                            menu.close();
                        },
                        icon: "Cancel"
                    }
                ];

                menu = skyward.modalLayer.showDialog("Select Values", dropdown, buttons, dialogOptions);
                menu.animationPromise.then(menu.animateModalContents());
                menu.content.find('.prompt.filterValue').each(function ()
                {
                    var filterValue = $(this);
                    filterValue.on('click', function () { setFilterValue($.extend({ enumType: valueBoxData.enumType }, filterValue.data()), filterValue); });
                });
            }
            else
            {
                menu = skyward.modalLayer.showDialog("Select a Value", dropdown, [], dialogOptions);
                menu.content.find('.filterValue').each(function ()
                {
                    var filterValue = $(this);
                    filterValue.on('click', function () { setFilterValue(filterValue.data(), filterValue); });
                });
            }

            menu.content.find('.addFilterValue').on('click', function ()
            {
                menu.close();
            });

            $.each(clickEvents, function (key, value)
            {
                menu.content.find(key).on('click', function () { value(setFilterValue, valueBox, treatPromptAsInUse); });
            });

            skyward.window.notifyDOMLoad(".filterValue");

            function setFilterValue(filterValueData, clickedInput)
            {
                if (filterValueData)
                {
                    let displayValue = null;
                    let svg = null;

                    if (typeof filterValueData.boolvalue === "boolean")
                    {
                        displayValue = filterValueData.boolvalue.toDisplayString();
                    }
                    else if (filterValueData.enumDisplayValue)
                    {
                        displayValue = filterValueData.enumDisplayValue;
                    }
                    else if (filterValueData.columnId)
                    {
                        displayValue = filterValueData.columnDescription || "Current Column Value";
                    }
                    else if (filterValueData.promptUniqueId)
                    {
                        displayValue = filterValueData.label || filterValueData.promptName;
                        svg = filterValueData.svgClass;
                    }
                    else if (filterValueData.binding)
                    {
                        displayValue = filterValueData.name;
                    }
                    else if (filterValueData.customValue)
                    {
                        displayValue = filterValueData.customDisplayValue;
                    }
                    else if (filterValueData.environmentVariableName)
                    {
                        displayValue = filterValueData.environmentVariableName;
                        svg = filterValueData.svgClass;
                    }
                    else if (clickedInput && clickedInput.length > 0)
                    {
                        displayValue = clickedInput.text();
                    }

                    skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, displayValue, filterValueData, svg, true);
                }
                menu.close();
            }

            function getSelectedItems()
            {
                var filterValueData = $.extend({}, dropdown.find(".filterValue").first().data());
                filterValueData.enumDisplayValue = "";
                var selectedValues = [];

                dropdown.find("input:checked").each(function ()
                {
                    var selectedValueData = $(this).closest(".filterValue").data();
                    selectedValues.push(selectedValueData.enumCodeValue);
                    filterValueData.enumDisplayValue += (filterValueData.enumDisplayValue.length ? ", " : "") + (selectedValueData.enumDisplayValue || selectedValueData.enumValue);
                });

                filterValueData.list = { Value: selectedValues };

                return filterValueData;
            }
        };

        skyward.filterbuilder.selectField = function (controlIDToUpdate, data)
        {
            const allFieldsPanelTreeBrowse = $(`#${controlIDToUpdate}`);

            const firstDotIndex = data.fieldPath.indexOf(".");
            const hasDot = firstDotIndex >= 0;
            const absoluteFieldPath = hasDot ? data.fieldPath.substring(firstDotIndex + 1) : data.fieldPath;

            const searchData =
            {
                calculatedFieldName: undefined,
                fieldName: data.fieldName,
                fieldPath: data.fieldPath,
                fieldModule: data.moduleName,
                fieldObject: data.objectName,
                absoluteFieldPath: absoluteFieldPath,
                relationshipPath: data.fieldPathToParent,
                displayName: data.displayName,
                displayPathText: data.displayPathText,
                fieldType: data.fieldType,
                svgClass: data.svgClass,
                parameters: data.parameters ?? [],
                isCalculated: data.isCalculated,
                isOperation: data.isOperation
            };

            allFieldsPanelTreeBrowse.trigger("searchFieldSelected", [searchData]);
            skyward.window.closePopup();
        };

        // ToDo - Eventually this should be information that is passed into FilterBuilder from reporting instead of living here
        function convertBindingsToFriendlyNames(text)
        {
            if (text)
            {
                if (skyward.reporting.prompts?.promptCollection?.ConvertPromptBindingsToFriendlyNames)
                {
                    text = skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(text);
                }

                if (skyward.reporting.calculatedFields?.ConvertBindingsToFriendlyNames)
                {
                    text = skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames(text);
                }
            }

            return text;
        }

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);